import { articles, categories, type Article, type Category } from "@/mocks/articles";

export function getCategoryById(id: string): Category | undefined {
  return categories.find((cat) => cat.id === id);
}

export function getCategoryName(id: string): string {
  return getCategoryById(id)?.name ?? "热点话题";
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((cat) => cat.slug === slug);
}

export function sortByHeat(list: Article[]): Article[] {
  return [...list].sort((a, b) => b.heat - a.heat);
}

export function sortByDate(list: Article[]): Article[] {
  return [...list].sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));
}

export function countByCategory(categoryId: string): number {
  return articles.filter((item) => item.categoryId === categoryId).length;
}

export function getRelatedArticles(article: Article, limit = 3): Article[] {
  const sameCategory = articles.filter(
    (item) => item.id !== article.id && item.categoryId === article.categoryId,
  );
  const others = articles.filter((item) => item.id !== article.id && item.categoryId !== article.categoryId);
  return [...sameCategory, ...sortByHeat(others)].slice(0, limit);
}